import { PlaylistService } from './../../api/services/playlist-service';
import {Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChange} from '@angular/core';
import {SongDetailComponent} from '../';
import {AuthService, SongsService} from '../../api/';
import {Helper} from '../../helper';
import {MdDialog, MdDialogRef} from '@angular/material';
import {AlbumsService} from '../../api';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {PlayerService} from '../../player';
import { NgBlockUI, BlockUI } from 'ng-block-ui';

@Component({
    selector: 'song',
    templateUrl: './song-item.component.html',
    styleUrls: ['./song-item.component.css']
})
export class SongItemComponent implements OnInit, OnChanges {
    @BlockUI() blockUI: NgBlockUI;
    @Input() song: any;
    @Input() artistTracks: boolean = false;
    @Input() playlistTracks:boolean = false;
    @Input() advanced: boolean = false;
    @Input() inedx: any;
    @Input() artist: any
    @Input() type: string = '';
    @Input() hideOptions: boolean = false;
    @Input() hide: boolean = false;
    @Input() showDeleteSongFromPlaylist: boolean = false;
    @Output() refreshListing: EventEmitter<any> = new EventEmitter();
    @Input() queueCheck: boolean;
    dialogRef: MdDialogRef<SongDetailComponent>;
    album: any;
    public checkIfMobile: boolean = false;
    dbl: boolean = true;
    private isThisSongPlaying: boolean = false;
    private songId: number = 0;
    private playerEventSubscriber = null;
    public is_download: boolean = false;
    private helper = new Helper();
    public checkIfSmallMobile: boolean = false;
    playingId:number = 0;
    disable = true;
    public icon = 'more_vert';

    constructor(private authService: AuthService, private songsService: SongsService, private playerService: PlayerService, private route: ActivatedRoute, private router: Router, public dialog: MdDialog, private albumService: AlbumsService, private playlistService: PlaylistService) {
        if(this.queueCheck == true) {
            this.queueCheck = true;
        } else {
            this.queueCheck = false;
        }
    }

    ngOnInit() {
        this.checkIfMobile = false;
        if (screen.width <= 640) {
            this.checkIfMobile = true;
        }
        if (screen.width <= 360) {
            this.checkIfSmallMobile = true;
        }
    }

    fancyTimeFormat(time)
    {
        var mins = null;
        // Hours, minutes and seconds
        // var hrs = ~~(time / 3600);
        if(time > 59) {
            mins = ~~((time % 3600) / 60);
        }
        // var secs = ~~time % 60;
        //
        // // Output like "1:01" or "4:03:59" or "123:03:59"
        // var ret = "";
        //
        // if (hrs > 0) {
        //     ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
        // }
        //
        // ret += "" + mins + ":" + (secs < 10 ? "0" : "");
        // ret += "" + secs;
        return mins;
    }

    mouseHovering(index) {
        this.song.isHovering = true;
    }

    mouseLeaving(index) {
        this.song.isHovering = false;
    }

    toggleControls() {
        this.song.isHovering = !this.song.isHovering;
        if(this.song.isHovering == false) {
            this.icon = 'more_vert';
        } else {
            this.icon = 'more_horiz';
        }
    }
    
    routeToAvatarSource(event) {
        let itemType = (typeof this.song !== 'undefined' && typeof this.song._type !== 'undefined') ? this.song._type : 'playlist';

        switch (itemType) {
            case 'song':
                if (this.song.album && this.song.album.slug) {
                    this.router.navigate(['/collection', this.song.album.slug]);
                } else {
                    this.router.navigate(['/song', this.song.slug]);
                }
                break;
            case 'artist':
                this.router.navigate(['/artist', this.song.slug]);
                break;
            case 'album':
                this.router.navigate(['/collection', this.song.slug]);
                break;
            case 'playlist':
                if (this.song.type != 'R') {
                    this.router.navigate(['/playlist', this.song.slug]);
                }
                break;
            case 'account':
                this.router.navigate(['/account', this.song.slug]);
                break;
        }

    }

    ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
        this.songId = this.song.id;

        if (this.song._type === 'song') {
            this.isThisSongPlaying = this.playerService.getCurrentTrack() === this.songId;

            this.playerEventSubscriber = this.playerService.playerEvent.subscribe((event) => {
                if (event.type === 'track:id' && event.data === this.songId) {
                    this.isThisSongPlaying = true;
                } else if (event.type === 'track:id' && event.data !== this.songId) {
                    this.isThisSongPlaying = false;
                }
                if (this.isThisSongPlaying === true && event.type === 'music:isPlaying' && event.data === false) {
                    this.isThisSongPlaying = false;
                    // this.song.isHovering = false;
                }
            });
        }
    }

    routeToArtists() {
        localStorage.setItem('labelName', this.song.artist.label);
        this.router.navigate(['/allArtists']);
    }

    playIt() {
        this.songId = this.song.id;
        if (!this.isThisSongPlaying) {
            let trackId = this.playerService.addTrack(this.song);

            this.playerService.showLoading(true);

            if (this.playerService.getCurrentTrack() === this.songId) {
                this.playerService.play();
                this.playerService.showLoading(false);
                return;
            }
            let songs: any;
            let itemType = (typeof this.song !== 'undefined' && typeof this.song._type !== 'undefined') ? this.song._type : 'playlist';
            let currentTrackData = this.playerService.currentTrackData();
            let trackId2 = this.playerService.addTrack(this.song);
            this.playerService.playTrack(trackId);
            this.playerService.showLoading(false);
            this.isThisSongPlaying = true;
        } else {
            this.playerService.pause();
            this.isThisSongPlaying = false;
        }
    }

    openSongDetail(event) {
        console.log(this.song);
        this.blockUI.start('Loading, please wait...');
        var width = '', height = '';
        var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
        width = '37%';
        setTimeout(()=> {
            this.dialogRef = this.dialog.open(SongDetailComponent, {
                width: width
            });
            if(this.playlistTracks == true && (this.song.credits && this.song.credits.length != 0) || (this.song.publishers && this.song.publishers.length != 0) || (this.song.writers && this.song.writers.length != 0)) {
                this.dialogRef.componentInstance.song = this.song;
            } else {
                this.dialogRef.componentInstance.slug = this.song.slug;
            }
            return false;
        }, 1000)
        return false;
    }

    handleSongDeleted() {
        this.song = '';
        this.refreshListing.emit({refresh: true});
        // to detect the change when any song is deleted from the playlist without page refresh
        this.playlistService.isPlaylistUpdated.next(true);
    }

}



// WEBPACK FOOTER //
// ./src/app/songs/song-item/song-item.component.ts